import { getNumberValue, getObjectValue } from 'utillities';
import { HandleBacksolveScenarioParams } from './types';

const handleBacksolveScenario = (params: HandleBacksolveScenarioParams) => {
  const {
    backsolveCapTable,
    backsolveMaturity,
    backsolveVolatility,
    capTableSelectionCell,
    changes,
    enableCells,
    isApproachWithOPM,
    maturityCell,
    primaryCapTable,
    riskFreeRateCell,
    volatilityCell,
  } = params;

  const { id: primaryCapTableId } = getObjectValue(primaryCapTable);

  if (capTableSelectionCell) {
    capTableSelectionCell.readOnly = true;
    changes?.push({ cell: capTableSelectionCell, value: getNumberValue(backsolveCapTable ?? primaryCapTableId) });
  }

  if (isApproachWithOPM) {
    // Read-only OPM Inputs
    enableCells?.({ cells: [maturityCell, riskFreeRateCell, volatilityCell], isReadOnly: true });

    if (maturityCell) {
      changes?.push({ cell: maturityCell, value: getNumberValue(backsolveMaturity) });
    }

    if (riskFreeRateCell) {
      changes?.push({ cell: riskFreeRateCell, value: 0 });
    }

    if (volatilityCell) {
      changes?.push({ cell: volatilityCell, value: getNumberValue(backsolveVolatility) });
    }
  }
};

export default handleBacksolveScenario;
